module.exports = __webpack_public_path__ + "static/media/username_icon.c8e2173e.svg";